import { AxiosService } from '../../services/axiosService';

export const getDetergentNonPagingApi = () => {
  return AxiosService.get('detergent/non-paging');
};
